import globalAxios from "@/services/global-axios";

export const state = {
  categories: [],
  categoriesWithPaginate: [],
  categoriesWithNoPaginate: [],
  category: {},
};

export const mutations = {
  GET_CAREGORIES(state, data) {
    state.categories = data;
  },
  GET_CAREGORIES_WITH_PAGINATION(state, data) {
    state.categoriesWithPaginate = data;
  },
  GET_CAREGORIES_WITH_NO_PAGINATION(state, data) {
    state.categoriesWithNoPaginate = data;
  },
  GET_CAREGORY(state, data) {
    state.category = data;
  },
};

export const getters = {
  categories(state) {
    return state.categories;
  },
  categoriesWithPaginate(state) {
    return state.categoriesWithPaginate;
  },
  categoriesWithNoPaginate(state) {
    return state.categoriesWithNoPaginate;
  },
  category(state) {
    return state.category;
  },
};

export const actions = {
  getCategories({ commit } , page) {
    globalAxios
      .get(`admin/categories`, {
        params: {
          isParent: true,
          page:page,
          status:1
        },
      })
      .then((res) => {
        if (res.status == 200) {
          commit("GET_CAREGORIES", res.data.items.data);
          commit("GET_CAREGORIES_WITH_PAGINATION", res.data.items);
        }
      })
      .catch((err) => {
        // const error = Object.values(err)[2].data;
        console.log("err", err);
      });
  },
  getAllCategories({ commit } , page) {
    globalAxios
      .get(`admin/categories`, {
        params: {
          isParent: true,
          page:page,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          commit("GET_CAREGORIES", res.data.items.data);
          commit("GET_CAREGORIES_WITH_PAGINATION", res.data.items);
        }
      })
      .catch((err) => {
        // const error = Object.values(err)[2].data;
        console.log("err", err);
      });
  },
  getCategoriesWithNoPaginate({ commit }) {
    globalAxios
      .get(`admin/categories`, {
        params: {
          paginate: 0,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          commit("GET_CAREGORIES_WITH_NO_PAGINATION", res.data.items.data);
        }
      })
      .catch((err) => {
        // const error = Object.values(err)[2].data;
        console.log("err", err);
      });
  },
  getCategory({ commit }, id) {
    globalAxios
      .get(`admin/categories/${id}`)
      .then((res) => {
        if (res.status == 200) {
          commit("GET_CAREGORY", res.data.items);
        }
      })
      .catch((err) => {
        // const error = Object.values(err)[2].data;
        console.log("err", err);
      });
  },
};
